<template>
    <div class='noticeListInfo'>
        <div style="height: 100%;">
            <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="finText"
            @load="onLoad"
            offset ="10"
            :immediate-check="false"
            > 
                <div v-if="msgType=='FENCE'||msgType=='TOUCH'">
                    <div v-for="message,i in list" :key="i" class="van-clearfix">
                      <div class="content_title">{{message.date}}</div>
                        <div class="content_div">
                            <div :class="'content_flex read'+item.readStatus" v-for="item,index in message.items" :key="index">
                                <div class="flex_left">
                                    <div class="read" ></div>
                                </div>
                                <div class="flex_right">
                                    <div class="right_top">{{ item.msgContent }}</div>
                                    <div class="right_bottom font14">{{ item.messageTimes }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="msgType=='SOS'">
                    <div v-for="message,i in list" :key="i" class="van-clearfix">
                        <div class="sos_time">{{ message.messageTime }}</div>
                        <div class="sos_content">
                            <div class="sos_content_title gray font18"><span class="acter_span"></span><span>{{ message.msgContent.split('，')[0] }}</span></div>
                            <div class="sos_content_content">
                                <div class="constent_first gray font16">发送位置</div>
                                <div class="constent_scend font18">{{ message.address }}</div>
                                <div class="constent_third">请及时关注，当前可能不方便接听电话，请谨慎回电。</div>
                            </div>
                            <div class="sos_content_foot" @click='toUrl'>
                                <div class="foot_first font16">查看实时位置</div>
                                <div><img src="@/assets/img/equipment/right.png" alt=""></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="msgType=='SUGGEST'">
                    <div v-for="item,i in list" :key="i" class="van-clearfix">
                        <div class="sos_time">{{ item.messageTime }}</div>
                        <div class="sos_content font16">
                             <p class="tit font18">{{item.suggest.title}}</p>
                             <p class="sug flex-between" v-for="(obj,j) in item.suggest.suggestList" :key='j' @click="gotoDetail(obj)">
                                <span>{{obj.score}}</span><span class="colorBlue">详情 ></span>
                             </p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-for="item,i in list" :key="i" class="van-clearfix">
                        <div class="sos_time">{{ item.messageTime }}</div>
                        <div class="sos_content" v-html="item.msgContent">
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/mine/noNotice.png")'><br />{{text}}</div></div>
    </div>
</template>
  <script>
    import {pageListMessageInfo} from "@/api/api.notice";

    export default {
      data() {
        return {
          list:[],
          loading: false,
          finished: true,
          finText:'',
          text:'',
          msgType:this.$route.query.msgType || 'home',
          userType:this.$store.state.loginUser.currentUserType,//3老师，5家长
          identityId:'',
          pageInfo:{
            pageNo:1,
            pageSize:10,
            totalPage:0
          }
        }
      },
      created(){
        if(this.userType==3){//老师
             this.identityId=this.$store.state.users.teacher.teacherId
       }else if(this.userType==5){//家长
             this.identityId=this.$store.state.users.parent.parentId
       }
        this.getList();
      },
      methods: {
        getList(){
          this.text='';
          const _this=this
          pageListMessageInfo({
            identityId:this.identityId,
            msgType:this.msgType,
            ...this.pageInfo
          }).then(res=>{
            this.pageInfo.tatolPage=res.result.totalPage
            if(res.result.list){
                if(this.msgType=='FENCE'||this.msgType=='TOUCH'){
                    let temp=this.groupByDate(res.result.list);
                 //   console.log(temp);

                    if(this.list.length==0){
                        
                        this.list=temp
                    }else{
                        if(_this.list[_this.list.length-1].date==temp[0].date){
                            temp[0].items.forEach((t)=>{
                                _this.list[_this.list.length-1].items.push(t)
                            })
                            temp.shift()
                            temp.forEach((item)=>{
                                _this.list.push(item)
                            })
                        }else{
                            temp.forEach((item)=>{
                                _this.list.push(item)
                            })
                        }
                    }
                }else {
                    if(this.list.length==0){
                        _this.list=res.result.list 
                    }else{
                        _this.list.concat(res.result.list)
                    }
                }
            }
            this.loading = false;
            if (this.pageInfo.pageNo >= this.pageInfo.tatolPage) {
                this.finished = true;
                this.finText='没有更多了'
            }else{
                this.finished=false;
            }
            if(res.result.totalNum==0){
                this.finText='';
                this.text='暂无消息'
            }
          })
        },
        groupByDate(data) {
            return data.reduce((result, item) => {
                item.messageTimes=item.messageTime.split(' ')[1];
                const existingGroup = result.find((group) => {
                   return group.date== item.messageTime.split(' ')[0];
                });
                if (existingGroup) {
                    
                    existingGroup.items.push(item);
                } else {
                result.push({
                    date: item.messageTime.split(' ')[0],
                    items: [item],
                });
                }
                return result;
            }, []);
        },
        gotoDetail(obj){
            sessionStorage.setItem('noticeCon',JSON.stringify(obj));
            this.gotoUrl('noticeDetail');
        },
        onLoad(){
            this.pageInfo.pageNo++
            this.getList()
        },
        toUrl(){
            if(mapOpen){
                this.gotoUrl('location');
            }
        }
      },
    }
  </script>
  <style lang="scss" >
  .noticeListInfo{
    // padding:.15rem .15rem .7rem;
    font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
    .content_title{
        padding-left: 0.24rem;
        padding-top: 0.18rem;
        padding-bottom: 0.08rem;
        font-size: .15rem;
        font-weight: 400;
        color: rgba(0,0,0,0.6);
    }
    .content_div{
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        padding: 0.32rem .12rem .08rem .32rem;
        .content_flex{
            display: flex;
            margin-bottom: 0.24rem;
            .flex_left{
                padding-top: .06rem;
                width: .16rem;
                .read{
                    width: 0.08rem;
                    height: 0.08rem;
                    border-radius: 50%;
                    background: #FFFFFF;
                    border: 2px solid #DCDCDC;
                }
                
            }
            .flex_right{
                width: 90%;
                .right_top{
                    font-size: 0.16rem;
                    font-weight: 400;
                    color: rgba(0,0,0,0.6);
                }
                .right_bottom{
                    font-weight: 400;
                    color: #999999;
                    line-height: 19px;
                    margin-top: 0.04rem;
                }
            }
            &.read0{
                .read{
                    width: 0.12rem;
                    height: 0.12rem;
                    border: 3px solid #0A59F7;
                }
                .right_top{
                    color:rgba(0,0,0,.9);
                    font-weight: 500;
                }
            }
        }
    }
    .sos_time{
        height: 0.44rem;
        line-height: 0.44rem;
        text-align: center;
        font-size: .15rem;
        font-weight: 400;
        color: rgba(0,0,0,0.6);
    }
    .sos_content{
       
        background: #FFFFFF;
        margin: 0 0.12rem;
        padding:0.15rem 0.12rem;
        border-radius: 8px;
        opacity: 1;
        white-space: pre-line;
        line-height: .22rem;
        .sos_content_title{
            height: 0.48rem;
            padding: 0;
            line-height: 0.48rem;
            border-bottom: 1px solid #dcdcdc;
            
        }
        .acter_span{
            width: 0.24rem;
            height: 0.24rem;
            background: #D1CACA;
            display: inline-block;
            border-radius: 50%;
            vertical-align: -11%;
            margin-right: 0.08rem;
        }
        .constent_first{
            width: 100%;
            text-align: center;
            margin: 0.2rem 0;
            
        }
        .constent_scend{
            width: 100%;
            text-align: center;
            margin-bottom: 0.2rem;
            font-weight: 400;
            color: rgba(0,0,0,0.9);
        }
        .constent_third{
            margin-bottom: 0.1rem;
            font-weight: 400;
            color: rgba(0,0,0,0.6);
            font-size: .13rem;
        }
        .sos_content_foot{
            display: flex;
            height: 0.48rem;
            border-top:1px solid #dcdcdc;
            justify-content: space-between;
            align-items: center;
            .foot_first{
                
                font-weight: 400;
                color: rgba(0,0,0,0.9);
            }
            img{
                width: 0.14rem;
                height: 0.14rem;
            }
        }
        .colorBlue{
            color:#0A59F7;
        }
        .tit{
            padding-bottom: .15rem;
            margin-bottom: .2rem;
            border-bottom: 1px solid #DCDCDC;
        }
        .sug{
           padding-bottom: .16rem;
           line-height: .16rem;
           &:last-child{
            padding-bottom: .05rem;
           }
        }
    }
  }
  
  </style>